export default __webpack_public_path__ + "static/jovana-7eb0f0b3185f2480e9d4e4ac8278b333.jpg";